module.exports = __webpack_public_path__ + "img/sort-icon-1.695f0805.png";